// extracted by mini-css-extract-plugin
module.exports = {"canvasHidden":"styles_canvasHidden__1U4jM","container":"styles_container__26zgc","content":"styles_content__220N-","textContent":"styles_textContent__1luVg"};